import React from "react";
import { STORIES } from "../../../constants/images";
export default function Story_empty({ setAddStoryModal, isOwner }) {
  return (
    <div className="empty-stories-container">
      <img className="empty" src={STORIES.EMPTY_ICON} />
      <p>There isn't any story of this NFT.</p>
      {isOwner ? (
        <button
          className="dark py-2 px-4"
          onClick={() => {
            setAddStoryModal(true);
          }}
        >
          <img src={STORIES.ADD} />
          Add New Story
        </button>
      ) : null}
      {/* <div style={{ "paddingTop": "35px" }}><p>Learn more about the NFT Story here.</p></div> */}
      <div className="text-center pt-4" style={{  color: "var(--white) !important" }}>
        Learn more about GangstaBet Stories{" "}
        <a
          href="https://gangstabet.medium.com/announcing-gangstabet-stories-fb38e47b474"
          style={{ color: "var(--text-story-more)" }}
          target="_blank"
        >
          <u>here</u>.
        </a>
      </div>
    </div>
  );
}
